import i18n from 'i18n';
import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules';

export function stateValue(value:string): string {
  if (value === 'ACTIVE') {
    return i18n.t('common.grid.active');
  }

  if (value === 'INACTIVE') {
    return i18n.t('common.grid.inactive');
  }

  if (value === 'PARTIALLY_ACTIVE') {
    return i18n.t('common.grid.partiallyActive');
  }

  if (value === 'FAILED') {
    return i18n.t('common.grid.failed');
  }

  return i18n.t('common.grid.empty');
}

export default function stateValueFormatter({ value }: Partial<ValueFormatterParams>): string {
  return stateValue(value);
}
